import React from "react";
import { Tooltip, withStyles } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import { Grid, TextField } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import GanhoPesoTableForm from "./ganhoPesoTableForm";
import { useMonths } from "../hooks/useMonths";
import { useTranslations } from "adapters/i18n";
import { MESES_MAP } from "../ganhoPesoUtils";

export const GanhoPesoForm = (props) => {
  const { classes } = props;
  const months = useMonths();
  const { t } = useTranslations();

  const onChangeCurve = (event, mes) =>
    props.handleChangeMes(MESES_MAP[mes.Nome], event.target.value);

  return (
    <div classes={classes.resumoWrapper}>
      <Grid item>
        <Typography className={classes.tituloGanhoPesoForm} gutterBottom>
          {props.curva.IdCurvaGanhoPeso ? "Editar Curva" : "Nova Curva"}
        </Typography>
      </Grid>
      <Grid item>
        <Typography className={classes.subtitulo} gutterBottom>
          {t("weightGainCurve:curve-information")}
        </Typography>
      </Grid>
      <Grid item>
        <FormControl className={classes.textoCadastro}>
          <TextField
            value={props.curva.Nome}
            autoFocus
            id={"adornment-nome"}
            required
            label={t("weightGainCurve:curve-name")}
            error={props.erroNome}
            helperText={props.erroNome ? t("errors:name-exist-already") : ""}
            onChange={props.handleChangeNomeCurva}
          />
        </FormControl>
        <Grid item>
          <Typography className={classes.avisoMedias} gutterBottom>
            {t("weightGainCurve:average-monthly-description")}
          </Typography>
        </Grid>
        <Grid item>
          <GanhoPesoTableForm
            months={months}
            curves={props.curva}
            onChangeCurve={onChangeCurve}
          />
        </Grid>
      </Grid>
      <Grid item className={classes.botoesEmLinha}>
        <Button
          id="habilitarCurva"
          color="primary"
          className={classes.corpoBotoesForm}
          onClick={() => props.habilitarCurva(false)}
        >
          Cancelar
        </Button>
        <Tooltip
          title={
            props.mensagemBotaoDesabilitado ? (
              <Typography className={classes.textoTooltip}>
                {props.mensagemBotaoDesabilitado}
              </Typography>
            ) : (
              ""
            )
          }
          placement="right-end"
        >
          <span>
            <Button
              id="botaoAdicionar"
              disabled={props.habilitarBotao()}
              variant="contained"
              color="primary"
              onClick={() => props.adicionarCurva(props.curva)}
              className={classes.corpoBotoesForm}
            >
              {props.curva.IdCurvaGanhoPeso
                ? t("common:actions.save")
                : t("common:actions.add")}
            </Button>
          </span>
        </Tooltip>
        {props.curva.IdCurvaGanhoPeso ? (
          <Button
            onClick={() => props.abreDialogExclusao(props.curva)}
            className={classes.botaoExcluir}
          >
            <DeleteIcon style={{ marginRight: "0.4rem" }} />
            <Typography color="error">
              {t("weightGainCurve:delete-curve")}
            </Typography>
          </Button>
        ) : null}
      </Grid>
    </div>
  );
};
const styles = () => {
  return {
    textoCadastro: {
      width: 200,
      marginBottom: 16,
    },
    resumoWrapper: {
      height: 112,
      backgroundColor: "#fafafa",
    },
    textoMes: {
      marginRight: "30px",
      width: "5%",
    },
    corpoBotoesForm: {
      marginTop: "36px",
      marginRight: "20px",
      boxShadow: "none!important",
    },
    botaoExcluir: {
      marginTop: "36px",
      marginLeft: "auto",
      color: "#FF0000",
    },
    botoesEmLinha: {
      display: "flex",
    },
    tituloGanhoPesoForm: {
      fontFamily: "Roboto",
      fontSize: 20,
      fontWeight: "bold",
      color: "#212121",
    },
    subtitulo: {
      fontFamily: "Roboto",
      fontSize: 14,
      fontWeight: "bold",
      color: "#757575",
      marginTop: "16px",
    },
    avisoMedias: {
      fontSize: "14px",
      fontWeight: "bold",
      fontStretch: "normal",
      color: "#333",
      marginTop: "16px",
    },
    textoTooltip: {
      color: "#ffffff",
      fontSize: 14,
      maxWidth: "220px",
      maxHeight: "80px",
      padding: "9px 9px 9px 16px",
    },
  };
};

export default withStyles(styles)(GanhoPesoForm);
